import React from 'react';

import constants from 'constants/constants';
import moment from 'moment-timezone';
import { Control, Controller, FieldArrayWithId, UseFormSetValue } from 'react-hook-form';

import { Details, Version } from 'components/common/UploadFileModal/components/programLibrary.types';
import classes from 'components/common/UploadFileModal/mainFilesListTable.module.scss';

import { Checkbox } from 'components/DesignSystem/Checkbox';

type Props = {
    fields: FieldArrayWithId<Details, 'versions'>[];
    control: Control<Details>;
    setValue: UseFormSetValue<Details>;
    list: Version[];
};
const XerFilesListTable = ({ fields, control, list, setValue }: Props) => {
    const checkAll = () => {
        const flag = list.every((i) => i.download);
        fields.forEach((item, index) => {
            setValue(`versions.${index}.download`, !flag, { shouldDirty: true });
        });
    };

    const check = (e, value) => {
        setValue(e.target.name, value);
    };

    return (
        <div data-testid={'table-container'} className={classes.tableContainer}>
            <table data-testid={'table'} className={classes.table}>
                <tbody>
                    <tr>
                        <th>
                            <div data-testid={'checkbox-all'} className={classes.checkboxContainer}>
                                <Checkbox checked={list.every((i) => i.download)} onChange={checkAll} />
                                <span>All</span>
                            </div>
                        </th>
                        <th>Version ID</th>
                        <th>Version (P6 Project name)</th>
                        <th>Date</th>
                    </tr>
                    {fields.map((row, index) => {
                        const { versionId, versionDate, versionName } = row;
                        return (
                            <tr key={row.id}>
                                <td>
                                    <Controller
                                        render={({ field }) => (
                                            <Checkbox {...field} checked={field.value} onChange={check} />
                                        )}
                                        name={`versions.${index}.download`}
                                        control={control}
                                    />
                                </td>
                                <td>{versionId}</td>
                                <td>{versionName}</td>
                                <td>{versionDate && moment(versionDate).format(constants.formats.date.default)}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default XerFilesListTable;
